export default __webpack_public_path__ + "static/media/lms.d1da4031.svg";